import { render, staticRenderFns } from "./actions_column_customer_formats.vue?vue&type=template&id=a0fb17f8"
import script from "./actions_column_customer_formats.vue?vue&type=script&lang=js"
export * from "./actions_column_customer_formats.vue?vue&type=script&lang=js"
import style0 from "./actions_column_customer_formats.vue?vue&type=style&index=0&id=a0fb17f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports